/**
 * Controller for AppManager
 */
define('controllers/mysetting/teamaccount/add.member.account.role.permission.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('AddMemberAccountRolePermissionCtrl', ['$q', '$scope', '$location', '$stateParams', '$state', 'ngDialog', 'OpenApp', 'auiDialog', 'auiTeamAccountService',
        function ($q, $scope, $location, $stateParams, $state, ngDialog, OpenApp, auiDialog, auiTeamAccountService) {
            var Model = $scope.Model = {};
            if (!$stateParams.teamMemberInfo) {
                cancel();
            }
            Model.constant = {
                prodType: mainCons.appConstant.prodType
            }
            Model.memberResInfo = $stateParams.memberResInfo ? angular.copy($stateParams.memberResInfo) : {};
            (Model.memberResInfo.prodIDList && Model.memberResInfo.prodIDList.length > 0) ? Model.memberResInfo.prodConfine = 2 : Model.memberResInfo.prodConfine = 1;
            $scope.contains = AUI.BaseJSUtil.contains;
            $scope.cancel = cancel;
            $scope.previousStep = previousStep;
            $scope.nextStep = nextStep;
            $scope.checkRoleAlliance = checkRoleAlliance;
            $scope.checkRoleDomain = checkRoleDomain;
            $scope.checkIsInGroup = checkIsInGroup;
            $scope.checkApp = checkApp;
            $scope.isHasRole = isHasRole;
            Model.selectProduct = 2;
            Model.agcTeamRoleToID = sysParamCfg.agcTeamRoleToID;
            Model.isHasAgcLegal = false;
            $scope.isShowPermission =isShowPermission;

            //是否展示权限
            function isShowPermission(serviceDomainRoleInfo) {
                var flag=false;
                if(Model.memberResInfo.currentRes && Model.memberResInfo.currentRes.length>0){
                    Model.memberResInfo.currentRes.forEach(function (res) {
                        if(serviceDomainRoleInfo.serviceDomainID == res.serviceDomainID){
                            if(res.permissionList && res.permissionList.length>0){
                                flag=true;
                            }
                        }
                    });
                }
                return flag;
            }
            
            //选择联盟的角色
            function checkRoleAlliance(roleAlliance) {
                if(roleAlliance.isAble){
                    if (roleAlliance.teamRoleType != 'Admin' && roleAlliance.teamRoleType != 'LegalSpecialist' &&  AUI.BaseJSUtil.contains(Model.memberResInfo.allianceRoles, 'Admin')) return;
                    var personalOwnRole = [];
                    if(Model.appUserRole && Model.appUserRole.teamRoleList && Model.appUserRole.teamRoleList.length>0){
                        Model.appUserRole.teamRoleList.forEach(function (item) {
                            personalOwnRole.push(item.teamRoleType)
                        })
                    }
                    var personalOwnAppRoles = [];
                    if(Model.appUserRole && Model.appUserRole.serviceDomainRoleInfoList && Model.appUserRole.serviceDomainRoleInfoList.length>0){
                        Model.appUserRole.serviceDomainRoleInfoList.forEach(function (val) {
                            if(val.serviceDomainID == '4' && val.roleList && val.roleList.length>0){
                                val.roleList.forEach(function (item) {
                                    personalOwnAppRoles.push(item.roleID)
                                })
                            }
                        })
                    }
                    var checkedRoles=[];
                    var checkAgcRoles = [];
                    if(Model.memberResInfo && Model.memberResInfo.teamRoleList && Model.memberResInfo.teamRoleList.length>0){
                        Model.memberResInfo.teamRoleList.forEach(function (value) {
                            checkedRoles.push(value.teamRoleType)
                        })
                    }
                    if(Model.memberResInfo && Model.memberResInfo.serviceDomainRoleInfoList && Model.memberResInfo.serviceDomainRoleInfoList.length>0){
                        Model.memberResInfo.serviceDomainRoleInfoList.forEach(function (e) {
                            if(e.serviceDomainID == '4' && e.roleList && e.roleList.length>0){
                                e.roleList.forEach(function (item) {
                                    checkAgcRoles.push(item.roleID)
                                })
                            }
                        })
                    }
                    if($scope.mainUserID && !AUI.BaseJSUtil.contains(personalOwnRole,'LegalSpecialist') && roleAlliance.teamRoleType == 'Admin' && checkedRoles && checkedRoles.length>0
                    && AUI.BaseJSUtil.contains(checkedRoles,roleAlliance.teamRoleType) && AUI.BaseJSUtil.contains(checkedRoles,'LegalSpecialist')
                    || AUI.BaseJSUtil.contains(personalOwnRole,'Admin') && !AUI.BaseJSUtil.contains(personalOwnAppRoles,Model.agcTeamRoleToID.legal) && AUI.BaseJSUtil.contains(checkAgcRoles,Model.agcTeamRoleToID.legal) && roleAlliance.teamRoleType == 'Admin' && AUI.BaseJSUtil.contains(checkedRoles,'Admin')){
                        auiDialog.warn("温馨提醒","您当前的权限无法修改该成员，请联系帐号持有者修改");
                        return;
                    }
                    if (roleAlliance.teamRoleType == 'Admin' && !AUI.BaseJSUtil.contains(Model.memberResInfo.allianceRoles, 'Admin')) {
                        Model.teamUserRole.teamRoleList.forEach(function (value) {
                            if(value.teamRoleType != 'LegalSpecialist'){
                                (Model.memberResInfo.allianceRoles && Model.memberResInfo.allianceRoles.length > 0) ? Model.memberResInfo.allianceRoles.push(value.teamRoleType) : Model.memberResInfo.allianceRoles = [value.teamRoleType];
                            }
                        });
                        //去掉法务
                        Model.memberResInfo.teamRoleList = angular.copy(AUI.BaseJSUtil.deleteObjFromArr(Model.teamUserRole.teamRoleList, 'teamRoleType', 'LegalSpecialist'));
                        //如果不包含运营或者新增去掉运营角色
                        if(Model.isAddTeamMember || !Model.memberResInfo.isHasOperatorRole){
                            Model.memberResInfo.teamRoleList = angular.copy(AUI.BaseJSUtil.deleteObjFromArr(Model.memberResInfo.teamRoleList, 'teamRoleType', 'Operator'));
                        }
                        Model.memberResInfo.serviceDomainRoleInfoList = angular.copy(Model.teamUserRole.serviceDomainRoleInfoList);

                        if(Model.memberResInfo.domainserviceRoleIDs){
                            Model.isHasAgcLegal = AUI.BaseJSUtil.contains(Model.memberResInfo.domainserviceRoleIDs, '4-？'+Model.agcTeamRoleToID.legal);
                            if(!Model.isHasAgcLegal){
                                deleteAgcLegal();
                            }
                        }else{
                            deleteAgcLegal();
                        }
                        if (Model.memberResInfo.serviceDomainRoleInfoList) {
                            //业务的所有角色
                            Model.memberResInfo.domainserviceRoleIDs = [];
                            Model.selectProduct = 2;
                        }
                        auiTeamAccountService.handlePermissionList(Model);
                        return;
                    }
                    if (roleAlliance.teamRoleType == 'Admin' && AUI.BaseJSUtil.contains(Model.memberResInfo.allianceRoles, 'Admin')) {
                        Model.memberResInfo.allianceRoles = [];
                        Model.memberResInfo.teamRoleList = [];
                        Model.memberResInfo.serviceDomainRoleInfoList = [];
                        Model.memberResInfo.domainserviceRoleIDs = [];
                        Model.memberResInfo.currentTeamRes = [];
                        Model.selectProduct = 2;
                        auiTeamAccountService.handlePermissionList(Model);
                        return;
                    }
                    if (Model.memberResInfo.teamRoleList) {
                        if (AUI.BaseJSUtil.contains(Model.memberResInfo.allianceRoles, roleAlliance.teamRoleType)) {
                            AUI.BaseJSUtil.arrayRemove(Model.memberResInfo.allianceRoles, roleAlliance.teamRoleType);
                            Model.memberResInfo.teamRoleList = AUI.BaseJSUtil.deleteObjFromArr(Model.memberResInfo.teamRoleList, 'teamRoleType', roleAlliance.teamRoleType);
                        } else {
                            if(roleAlliance.teamRoleType == 'LegalSpecialist'){
                                if(AUI.BaseJSUtil.contains(Model.memberResInfo.allianceRoles, 'Admin')){
                                    auiDialog.confirm("温馨提醒","勾选"+ roleAlliance.teamRoleName + "角色，该帐号将有权限代替您签署所有协议。", function () {
                                        Model.memberResInfo.teamRoleList && Model.memberResInfo.teamRoleList.length > 0 ? Model.memberResInfo.teamRoleList.push(roleAlliance) : Model.memberResInfo.teamRoleList = [roleAlliance];
                                        Model.memberResInfo.allianceRoles.push(roleAlliance.teamRoleType);
                                        //增加应用市场法务的角色
                                        if(Model.agcDomainInfo && Model.agcLegalRole){
                                            checkRoleDomain(Model.agcDomainInfo, Model.agcLegalRole,true);
                                        }
                                        Model.selectProduct = 2;
                                        auiTeamAccountService.handlePermissionList(Model);
                                    });
                                }else{
                                    auiDialog.warn("温馨提醒","勾选"+ roleAlliance.teamRoleName + "角色，需要先勾选系统管理下的管理员角色。");
                                    return;
                                }
                            }else{
                                Model.memberResInfo.teamRoleList && Model.memberResInfo.teamRoleList.length > 0 ? Model.memberResInfo.teamRoleList.push(roleAlliance) : Model.memberResInfo.teamRoleList = [roleAlliance];
                                Model.memberResInfo.allianceRoles.push(roleAlliance.teamRoleType);
                            }
                        }
                    } else {
                        if(roleAlliance.teamRoleType == 'LegalSpecialist'){
                            auiDialog.warn("温馨提醒","勾选"+ roleAlliance.teamRoleName + "角色，需要先勾选系统管理下的管理员角色。");
                            return;
                        }
                        Model.memberResInfo.teamRoleList && Model.memberResInfo.teamRoleList.length > 0 ? Model.memberResInfo.teamRoleList.push(roleAlliance) : Model.memberResInfo.teamRoleList = [roleAlliance];
                        (Model.memberResInfo.allianceRoles && Model.memberResInfo.allianceRoles.length > 0) ? Model.memberResInfo.allianceRoles.push(roleAlliance.teamRoleType) : Model.memberResInfo.allianceRoles = [roleAlliance.teamRoleType];
                    }
                    Model.selectProduct = 2;
                    auiTeamAccountService.handlePermissionList(Model);

                }
            }


            //去掉应用市场的法务角色
            function deleteAgcLegal() {
                Model.memberResInfo.serviceDomainRoleInfoList.forEach(function (serviceDomainRoleInfo) {
                    if(serviceDomainRoleInfo.serviceDomainID == '4'){
                        serviceDomainRoleInfo.roleList = angular.copy(AUI.BaseJSUtil.deleteObjFromArr(serviceDomainRoleInfo.roleList, 'roleID',Model.agcTeamRoleToID.legal));
                    }
                })
            }
            
            //选择生态角色  flag为true不提示
            function checkRoleDomain(serviceDomainInfo, role,flag) {
                if(role.isAble){
                    if(AUI.BaseJSUtil.contains(Model.memberResInfo.allianceRoles, 'Admin') && role.roleID == Model.agcTeamRoleToID.manager)return;
                    if(role.roleID == Model.agcTeamRoleToID.appManager && AUI.BaseJSUtil.contains(Model.memberResInfo.domainserviceRoleIDs, serviceDomainInfo.serviceDomainID + "-？" + Model.agcTeamRoleToID.manager)) return;
                    Model.memberResInfo.domainserviceRoleIDs && Model.memberResInfo.domainserviceRoleIDs.length > 0 && (Model.memberResInfo.domainserviceRoleIDs = AUI.BaseJSUtil.unique(Model.memberResInfo.domainserviceRoleIDs));
                    //如果是单纯的添加联盟的法务并且法务已经选择了
                    if(flag && AUI.BaseJSUtil.contains(Model.memberResInfo.domainserviceRoleIDs, serviceDomainInfo.serviceDomainID + "-？" + role.roleID)) return;
                    //这个是不走js添加服务的情况
                    var personappUserRole = [];
                    if(Model.appUserRole && Model.appUserRole.serviceDomainRoleInfoList && Model.appUserRole.serviceDomainRoleInfoList.length>0){
                        Model.appUserRole.serviceDomainRoleInfoList.forEach(function (val) {
                            if(val.serviceDomainID == 4 && val.roleList && val.roleList.length>0){
                                val.roleList.forEach(function (item) {
                                    personappUserRole.push(item.roleID)
                                })
                            }
                        })
                    }
                    if($scope.mainUserID && !AUI.BaseJSUtil.contains(personappUserRole,Model.agcTeamRoleToID.legal) && (role.roleID == Model.agcTeamRoleToID.appManager || role.roleID == Model.agcTeamRoleToID.manager)
                        && AUI.BaseJSUtil.contains(Model.memberResInfo.domainserviceRoleIDs, serviceDomainInfo.serviceDomainID + "-？" + role.roleID)
                        && AUI.BaseJSUtil.contains(Model.memberResInfo.domainserviceRoleIDs, serviceDomainInfo.serviceDomainID + "-？" + Model.agcTeamRoleToID.legal)){
                        auiDialog.warn("温馨提醒","您当前的权限无法修改该成员，请联系帐号持有者修改");
                        return;
                    }
                    if (!flag && (((role.roleID ==Model.agcTeamRoleToID.legal && AUI.BaseJSUtil.contains(Model.memberResInfo.allianceRoles, 'LegalSpecialist'))
                        || ((AUI.BaseJSUtil.contains(Model.memberResInfo.allianceRoles, 'Admin') || checkIsInGroup(serviceDomainInfo, role))  && role.roleID !=Model.agcTeamRoleToID.legal)))) return;
                    if (AUI.BaseJSUtil.contains(Model.memberResInfo.domainserviceRoleIDs, serviceDomainInfo.serviceDomainID + "-？" + role.roleID)) {
                        AUI.BaseJSUtil.arrayRemove(Model.memberResInfo.domainserviceRoleIDs, serviceDomainInfo.serviceDomainID + "-？" + role.roleID);
                        Model.memberResInfo.serviceDomainRoleInfoList && Model.memberResInfo.serviceDomainRoleInfoList.forEach(function (value) {
                            if (value.serviceDomainID == serviceDomainInfo.serviceDomainID) {
                                value.roleList = AUI.BaseJSUtil.deleteObjFromArr(value.roleList, 'roleID', role.roleID);
                            }
                        });
                        if (role.includeRoleIDList && role.includeRoleIDList.length > 0) {
                            role.includeRoleIDList.forEach(function (value) {
                                AUI.BaseJSUtil.arrayRemove(Model.memberResInfo.domainserviceRoleIDs, serviceDomainInfo.serviceDomainID + "-？" + value);
                                //根据角色id获取角色
                                var includerole = auiTeamAccountService.getRoleByRoleID(value);
                                Model.memberResInfo.serviceDomainRoleInfoList && Model.memberResInfo.serviceDomainRoleInfoList.forEach(function (value) {
                                    if (value.serviceDomainID == serviceDomainInfo.serviceDomainID) {
                                        value.roleList = AUI.BaseJSUtil.deleteObjFromArr(value.roleList, 'roleID', includerole.roleID);
                                    }
                                });
                            })
                        }
                    } else {
                        if(role.roleID ==Model.agcTeamRoleToID.legal && serviceDomainInfo.serviceDomainID == '4' && !flag){
                            if(AUI.BaseJSUtil.contains(Model.memberResInfo.domainserviceRoleIDs, serviceDomainInfo.serviceDomainID + "-？" + Model.agcTeamRoleToID.manager) || AUI.BaseJSUtil.contains(Model.memberResInfo.domainserviceRoleIDs, serviceDomainInfo.serviceDomainID + "-？" + Model.agcTeamRoleToID.appManager)){
                                auiDialog.confirm("温馨提醒","勾选"+ Model.agcLegalRole.roleName + "角色，该帐号将有权限代替您签署应用市场相关的协议。", function () {
                                    selectDomainserviceRole(serviceDomainInfo,role);
                                    Model.selectProduct = 2;
                                    auiTeamAccountService.handlePermissionList(Model);
                                });
                            }else{
                                auiDialog.warn("温馨提醒","勾选"+ Model.agcLegalRole.roleName + "角色，需要先勾选应用市场下的管理员或者APP管理员角色。");
                                return;
                            }

                        }else{
                            selectDomainserviceRole(serviceDomainInfo,role);
                        }
                    }
                    Model.selectProduct = 2;
                    auiTeamAccountService.handlePermissionList(Model);
                    //如果是不包含应用市场管理员和APP管理员 并且选择的是应用市场领域下的
                    if(serviceDomainInfo.serviceDomainID == '4' && !AUI.BaseJSUtil.contains(Model.memberResInfo.domainserviceRoleIDs, serviceDomainInfo.serviceDomainID + "-？" + Model.agcTeamRoleToID.manager) && !AUI.BaseJSUtil.contains(Model.memberResInfo.domainserviceRoleIDs, serviceDomainInfo.serviceDomainID + "-？" + Model.agcTeamRoleToID.appManager) && AUI.BaseJSUtil.contains(Model.memberResInfo.domainserviceRoleIDs, serviceDomainInfo.serviceDomainID + "-？" + Model.agcTeamRoleToID.legal)){
                        checkRoleDomain(Model.agcDomainInfo, Model.agcLegalRole);
                    }
                }

            }
            
            //从没有到有去勾选业务角色代码
            function selectDomainserviceRole(serviceDomainInfo,role) {
                if(role.isAble){
                    (Model.memberResInfo.domainserviceRoleIDs && Model.memberResInfo.domainserviceRoleIDs.length > 0) ? Model.memberResInfo.domainserviceRoleIDs.push(serviceDomainInfo.serviceDomainID + "-？" + role.roleID) : Model.memberResInfo.domainserviceRoleIDs = [serviceDomainInfo.serviceDomainID + "-？" + role.roleID];
                    if (!Model.memberResInfo.serviceDomainRoleInfoList || Model.memberResInfo.serviceDomainRoleInfoList && Model.memberResInfo.serviceDomainRoleInfoList.length == 0) {
                        Model.memberResInfo.serviceDomainRoleInfoList = [];
                    }
                    auiTeamAccountService.addDomainRole(Model.memberResInfo.serviceDomainRoleInfoList, serviceDomainInfo, role);
                    if (role.includeRoleIDList && role.includeRoleIDList.length > 0) {
                        role.includeRoleIDList.forEach(function (value) {
                            if (!AUI.BaseJSUtil.contains(Model.memberResInfo.domainserviceRoleIDs, serviceDomainInfo.serviceDomainID + "-？" + value)) {
                                Model.memberResInfo.domainserviceRoleIDs.push(serviceDomainInfo.serviceDomainID + "-？" + value);
                                //根据角色id获取角色
                                var includerole = auiTeamAccountService.getRoleByRoleID(value);
                                auiTeamAccountService.addDomainRole(Model.memberResInfo.serviceDomainRoleInfoList, serviceDomainInfo, includerole);
                            }
                        })
                    }
                    if(Model.developerPermission && !AUI.BaseJSUtil.contains(Model.memberResInfo.allianceRoles, "Developer") && (role.roleID == Model.agcTeamRoleToID.manager || role.roleID ==Model.agcTeamRoleToID.developer || role.roleID == Model.agcTeamRoleToID.appManager)){
                        checkRoleAlliance(Model.developerPermission);
                    }
                }
            }
            
            //检查是否属于不能去掉的组
            function checkIsInGroup(serviceDomainRoleInfo, role) {
                var flag = false;
                serviceDomainRoleInfo.roleList.forEach(function (roleValue) {
                    if (AUI.BaseJSUtil.contains(roleValue.includeRoleIDList, role.roleID) && AUI.BaseJSUtil.contains(Model.memberResInfo.domainserviceRoleIDs, serviceDomainRoleInfo.serviceDomainID + "-？" + roleValue.roleID)) {
                        flag = true;
                    }
                });
                return flag;
            }
            
            function isHasRole(serviceDomainRoleInfo, domainserviceRoleIDs) {
                var flag = false;
                domainserviceRoleIDs.forEach(function (roleID) {
                    if (roleID.indexOf(serviceDomainRoleInfo.serviceDomainID + "-？")>-1) {
                        flag = true;
                    }
                })
                return flag;
            }
            
            //取消
            function cancel() {
                $state.go("mysetting.teamAccountInfoList", {reload: true});
            }
            
            //上一步
            function previousStep() {
                $state.go('mysetting.addMemberAccount.account', {
                    teamMemberInfo: $stateParams.teamMemberInfo,
                    memberResInfo: $stateParams.memberResInfo
                });
            }
            
            function checkApp(item) {
                if (item.prodID == -1) {
                    Model.productSelect = [];
                    Model.memberResInfo.prodIDList = [];
                }
                Model.productSelected =[];
                Model.productSelect.forEach(function (value) {
                    if(value.prodID){
                        Model.productSelected.push(value);
                    }
                })
                Model.productSelect = angular.copy(Model.productSelected);
            }
            
            //下一步
            function nextStep() {
                if (!((Model.memberResInfo.teamRoleList && Model.memberResInfo.teamRoleList.length > 0) || (Model.memberResInfo.domainserviceRoleIDs && Model.memberResInfo.domainserviceRoleIDs.length > 0))) {
                    auiDialog.warn("请选择角色");
                    return;
                }
                Model.memberResInfo.prodIDList = [];
                if (Model.selectProduct == 1 && Model.productSelect && Model.productSelect.length > 0 && !AUI.BaseJSUtil.contains(Model.memberResInfo.allianceRoles, 'Admin') && !AUI.BaseJSUtil.contains(Model.memberResInfo.allianceRoles, 'Accountant')) {
                    Model.memberResInfo.prodConfine = 2;
                    Model.productSelect.forEach(function (value) {
                        Model.memberResInfo.prodIDList.push(value.prodID);
                    });
                } else if (AUI.BaseJSUtil.contains(Model.memberResInfo.allianceRoles, 'Admin') || AUI.BaseJSUtil.contains(Model.memberResInfo.allianceRoles, 'Accountant')) {
                    Model.memberResInfo.prodConfine = 1;
                } else if (Model.selectProduct == 1 && Model.productSelect && Model.productSelect.length > 0) {
                    Model.memberResInfo.prodConfine = 2;
                }else if(Model.selectProduct == 3){
                    Model.memberResInfo.prodConfine = 3;
                    Model.productSelect =[];
                } else if((!Model.productSelect || (Model.productSelect && Model.productSelect.length == 0)) && Model.prodIDList && Model.prodIDList.length>0){
                    Model.memberResInfo.prodConfine = 2;
                    Model.memberResInfo.productList.forEach(function (value) {
                        Model.memberResInfo.prodIDList.push(value.prodID);
                    })
                }else {
                    Model.memberResInfo.prodConfine = 1;
                }
                $state.go('mysetting.addMemberAccount.confirm', {
                    teamMemberInfo: $stateParams.teamMemberInfo,
                    memberResInfo: Model.memberResInfo
                });
            }
            
            //查询列表
            function getAppList(prodIDList) {
                var defer = $q.defer();
                var getProductListRequest = {};
                var allApp = {"prodName": "所有APP", "prodID": -1};
                Model.memberResInfo.productList = [];
                //带分页事件的查询
                var req = {
                    maxReqCount: 5000,
                    prodStateList:[0,2,3,4]
                };
                if(prodIDList && prodIDList.length>0){
                    req.prodIDList = prodIDList;
                }else{
                    Model.memberResInfo.productList = [allApp];
                }
                getProductListRequest.req = req;
                OpenApp.getAppBriefList(getProductListRequest).then(function (data) {
                    Model.memberResInfo.productList = Model.memberResInfo.productList.concat(angular.copy(data.appBriefList));
                    if (Model.memberResInfo.prodIDList) {
                        Model.productSelect = [];
                        Model.memberResInfo.prodIDList.forEach(function (prodId) {
                            Model.memberResInfo.productList.forEach(function (product) {
                                if (prodId == product.prodID) {
                                    Model.productSelect.push(product);
                                }
                            })
                        })
                        
                    }
                    defer.resolve(data);
                }).catch(function () {
                    Model.memberResInfo.productList = [allApp];
                    defer.reject();
                });
                return defer.promise;
            }
            
            (function () {
                $scope.mainUserID = AUI.HDGWCall.getUserInfoValue('teamid');
                Model.memberResInfo.currentRes = [];
                auiTeamAccountService.getUserResourceListDetail().then(function (teamUserRole) {
                    Model.teamUserRole = teamUserRole;
                    //判断是否为新增
                    if(!Model.memberResInfo.teamRoleList && !Model.memberResInfo.serviceDomainRoleInfoList){
                        Model.isAddTeamMember = true;
                    }
                    if(Model.teamUserRole.serviceDomainRoleInfoList && Model.teamUserRole.serviceDomainRoleInfoList.length>0){
                        Model.teamUserRole.serviceDomainRoleInfoList.forEach(function (value) {
                            if(value.roleList && value.roleList.length>0){
                                value.roleList.forEach(function (item) {
                                    item.isAble = false;
                                })
                            }
                        })
                    }
                    if(Model.teamUserRole.teamRoleList && Model.teamUserRole.teamRoleList.length>0){
                        Model.teamUserRole.teamRoleList.forEach(function (value) {
                            value.isAble = false;
                        })
                    }
                    if (Model.memberResInfo.teamRoleList) {
                        Model.memberResInfo.allianceRoles = [];
                        Model.memberResInfo.teamRoleList.forEach(function (value) {
                            //判断包含运营角色与否
                            if(value.teamRoleType =='Operator'){
                                Model.memberResInfo.isHasOperatorRole = true;
                            }
                            Model.memberResInfo.allianceRoles.push(value.teamRoleType);
                        })
                    }
                    //为后面可以添加应用市场法务做文章
                    Model.teamUserRole && Model.teamUserRole.serviceDomainRoleInfoList.length>0 && Model.teamUserRole.serviceDomainRoleInfoList.forEach(function (value) {
                        if(value.serviceDomainID == "4"){
                            //应用市场领域
                            Model.agcDomainInfo = value;
                            if(Model.agcDomainInfo.roleList && Model.agcDomainInfo.roleList.length>0){
                                Model.agcDomainInfo.roleList.forEach(function (role) {
                                    if(role.roleID == Model.agcTeamRoleToID.legal){
                                        //应用市场法务的角色
                                        Model.agcLegalRole = role;
                                    }
                                })
                            }
                        }
                    });
                    if (AUI.BaseJSUtil.contains(Model.memberResInfo.allianceRoles, 'Admin')) {
                        Model.memberResInfo.teamRoleList = angular.copy(Model.teamUserRole.teamRoleList);
                        var isHasLegalSpecialist = AUI.BaseJSUtil.contains(Model.memberResInfo.allianceRoles, 'LegalSpecialist');
                        if(!isHasLegalSpecialist){
                            Model.memberResInfo.teamRoleList = angular.copy(AUI.BaseJSUtil.deleteObjFromArr(Model.teamUserRole.teamRoleList, 'teamRoleType', 'LegalSpecialist'));
                        }
                        //不含有运营的时候去掉运营角色
                        if(!Model.memberResInfo.isHasOperatorRole){
                            Model.memberResInfo.teamRoleList = angular.copy(AUI.BaseJSUtil.deleteObjFromArr(Model.memberResInfo.teamRoleList, 'teamRoleType', 'Operator'));
                        }
                        Model.memberResInfo.allianceRoles = [];
                        Model.memberResInfo.teamRoleList.forEach(function (value) {
                            if(isHasLegalSpecialist){
                                Model.memberResInfo.allianceRoles.push(value.teamRoleType);
                                Model.isHasAgcLegal = true;
                            }else{
                                if(value.teamRoleType !='LegalSpecialist'){
                                    Model.memberResInfo.allianceRoles.push(value.teamRoleType);
                                }
                            }
                        })
                    }
                    if (Model.memberResInfo.serviceDomainRoleInfoList) {
                        //业务的所有角色
                        Model.memberResInfo.domainserviceRoleIDs = [];
                        Model.selectProduct = 2;
                        auiTeamAccountService.handlePermissionList(Model);
                    }
                    Model.teamUserRole && Model.teamUserRole.teamRoleList.length>0 && Model.teamUserRole.teamRoleList.forEach(function (value) {
                        if(value.teamRoleType == "Developer"){
                            Model.developerPermission = value;
                        }
                    });
                    if(AUI.HDGWCall.getUserInfoValue('teamid')){
                        var consoleRoleArr = [];
                        auiTeamAccountService.getMemberResourceListDetail().then(function (teamUserRole) {
                            Model.appUserRole = teamUserRole;
                            if(teamUserRole.prodIDList && teamUserRole.prodIDList.length>0){
                                Model.prodIDList = teamUserRole.prodIDList;
                                getAppList(teamUserRole.prodIDList);
                            }else{
                                getAppList();
                            }
                            if(Model.appUserRole && Model.appUserRole.prodConfine && Model.appUserRole.prodConfine == '2' &&  Model.memberResInfo.productList &&  Model.memberResInfo.productList.length>0){
                                Model.memberResInfo.productList = angular.copy(AUI.BaseJSUtil.deleteObjFromArr(Model.memberResInfo.productList, 'prodName', '所有APP'));
                            }
                            if(Model.appUserRole && Model.appUserRole.serviceDomainRoleInfoList){
                                Model.appUserRole.serviceDomainRoleInfoList.forEach(function (appRole) {
                                    var appRoleArr = [];
                                    if(appRole.roleList.length > 0){
                                        appRole.roleList.forEach(function (val) {
                                            appRoleArr.push(val.roleID)
                                        });
                                        Model.teamUserRole.serviceDomainRoleInfoList.forEach(function (teamRole) {
                                            if(appRole.serviceDomainID == teamRole.serviceDomainID){
                                                teamRole.roleList.forEach(function (val) {
                                                    if(AUI.BaseJSUtil.contains(appRoleArr,val.roleID)){
                                                        val.isAble = true;
                                                    }
                                                })
                                            }
                                        })
                                    }
                                })
                            }
                            if(Model.appUserRole && Model.appUserRole.teamRoleList && Model.appUserRole.teamRoleList.length>0){
                                Model.appUserRole.teamRoleList.forEach(function (val) {
                                    consoleRoleArr.push(val.teamRoleType)
                                })
                            }
                            Model.teamUserRole.teamRoleList.forEach(function (val) {
                                if(AUI.BaseJSUtil.contains(consoleRoleArr,val.teamRoleType)){
                                    val.isAble = true;
                                }
                            })
                        });
                    }else{
                        if (Model.teamUserRole.serviceDomainRoleInfoList && Model.teamUserRole.serviceDomainRoleInfoList.length > 0){
                            Model.teamUserRole.serviceDomainRoleInfoList.forEach(function (val) {
                                if (val.roleList && val.roleList.length > 0) {
                                    val.roleList.forEach(function (item) {
                                        item.isAble = true;
                                    })
                                }
                            });
                        }
                        if(Model.teamUserRole.teamRoleList && Model.teamUserRole.teamRoleList.length>0){
                            Model.teamUserRole.teamRoleList.forEach(function (value) {
                                value.isAble = true;
                            })
                        }
                        getAppList();
                    }
                });
            })();
        }]);
});

